import { FUNDS_ORIGINS, FUNDS_ORIGINS_USER_PROFILE_KEYS } from 'components/FundsOriginDeclaration/constants';

export const getFundsOriginsCheckedStatus = userProfile => ({
    [FUNDS_ORIGINS.BENEFITS]: userProfile[FUNDS_ORIGINS_USER_PROFILE_KEYS[FUNDS_ORIGINS.BENEFITS]] ?? false,
    [FUNDS_ORIGINS.PRIVATE_LOANS]: userProfile[FUNDS_ORIGINS_USER_PROFILE_KEYS[FUNDS_ORIGINS.PRIVATE_LOANS]] ?? false,
    [FUNDS_ORIGINS.FINANCIAL_INVESTMENTS]:
        userProfile[FUNDS_ORIGINS_USER_PROFILE_KEYS[FUNDS_ORIGINS.FINANCIAL_INVESTMENTS]] ?? false,
    [FUNDS_ORIGINS.REAL_STATE_INVESTMENTS]:
        userProfile[FUNDS_ORIGINS_USER_PROFILE_KEYS[FUNDS_ORIGINS.REAL_STATE_INVESTMENTS]] ?? false,
});
